import {
  accountType,
  subAccountPageSearchParams,
  supportSubAccountTypeList,
} from '..';

// 获取URL预设的创建子账户类型
export const getCreateSubAccountTypeFromSearchParams = () => {
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    // url上是否有 createSubAccount 参数
    const hasCreateSubAccountParams = searchParams.has(
      subAccountPageSearchParams.SHOW_CREATE_SUB_ACCOUNT_MODAL,
    );
    // url上 createSubAccount 参数的值
    const createAccountType = searchParams.get(
      subAccountPageSearchParams.SHOW_CREATE_SUB_ACCOUNT_MODAL,
    ) as accountType;

    // url上 showGuide 参数的值
    const showGuide = searchParams.get(
      subAccountPageSearchParams.SHOW_SELECT_ACCOUNT_MODAL_AND_GUIDE,
    ) as string;

    return {
      hasCreateSubAccountParams,
      createAccountType,
      showGuide,
    };
  }

  return {};
};

// 根据URL参数判断是否打开创建子账户弹窗
export const isShowCreateSubAccount = () => {
  const { hasCreateSubAccountParams, createAccountType, showGuide } =
    getCreateSubAccountTypeFromSearchParams();

  // 需要显示伊斯兰引导层时
  if (showGuide === 'islamic') {
    return 'selectModal';
  }

  // createSubAccount参数存在时，判断该参数是否有值
  if (hasCreateSubAccountParams) {
    // 参数的值是不支持的账户类型，显示账户类型选择弹窗
    if (
      !createAccountType ||
      !Object.values(supportSubAccountTypeList).includes(createAccountType)
    ) {
      return 'selectModal';
    }
    // 参数有值，显示创建弹窗
    return 'createModal';
  }
  return '';
};
